import * as React from 'react'
import styles from './InfoWindow.module.scss'
import { Link } from 'react-router'
import { waterTestingMapPinInfo_info } from '../../data-access/__generated__/types'

interface InfoWindowProps {
  facilityInfo: waterTestingMapPinInfo_info
  facilityId: number
}

export class InfoWindow extends React.Component<InfoWindowProps> {
  constructor(props: InfoWindowProps) {
    super(props)
  }

  render() {
    const {
      facilityName,
      address,
      city,
      state,
      zip,
      fixtureCount,
      sampleCount,
      exceedanceCount
    } = this.props.facilityInfo
    const { facilityId } = this.props

    return (
      <div className={styles.infoWindow}>
        <h4 className={styles.facilityName}>{facilityName}</h4>

        <div className={styles.address}>
          <p>{address}</p>
          <span>
            {city}
            {city && state && ', '}
            {state} {zip}
          </span>
        </div>

        <div className={styles.facilityCounts}>
          <span>
            {fixtureCount}
            <sub>Fixtures</sub>
          </span>
          <span>
            {sampleCount}
            <sub>Samples</sub>
          </span>
          <span>
            {exceedanceCount}
            <sub>Exceedances</sub>
          </span>
        </div>

        <Link
          to={`/details?facilityId=${facilityId}&facilityName=${encodeURIComponent(
            facilityName
          )}`}
          className={styles.detailsLink}
        >
          View Details &gt;
        </Link>
      </div>
    )
  }
}
